import React, { useContext, useEffect, useState } from 'react'
import {Input, VStack, HStack, Button, Text,
  Collapse
} from '@chakra-ui/react'
import { useDebounce } from 'react-use'
import {} from 'react-icons/ai'
import Card from './Card'
import { AppContext } from '../providers/AppProvider'


const LocationInput = ({onComplete = () => null, defaultValue=''}) => {

  const [locationQuery, setLocationQuery] = useState('');
  const [isFocused, setIsFocued] = useState(false);
  const [autocompleteResponses, setAutocompleteResponses] = useState([{"description":"London, UK","matched_substrings":[{"length":6,"offset":0}],"place_id":"ChIJdd4hrwug2EcRmSrV3Vo6llI","reference":"ChIJdd4hrwug2EcRmSrV3Vo6llI","structured_formatting":{"main_text":"London","main_text_matched_substrings":[{"length":6,"offset":0}],"secondary_text":"UK"},"terms":[{"offset":0,"value":"London"},{"offset":8,"value":"UK"}],"types":["locality","political","geocode"]},{"description":"London Bridge, London, UK","matched_substrings":[{"length":6,"offset":0}],"place_id":"ChIJxRO7WVEDdkgRrGM1fCYoHqY","reference":"ChIJxRO7WVEDdkgRrGM1fCYoHqY","structured_formatting":{"main_text":"London Bridge","main_text_matched_substrings":[{"length":6,"offset":0}],"secondary_text":"London, UK"},"terms":[{"offset":0,"value":"London Bridge"},{"offset":15,"value":"London"},{"offset":23,"value":"UK"}],"types":["tourist_attraction","point_of_interest","establishment"]},{"description":"London Eye, London, UK","matched_substrings":[{"length":6,"offset":0}],"place_id":"ChIJc2nSALkEdkgRkuoJJBfzkUI","reference":"ChIJc2nSALkEdkgRkuoJJBfzkUI","structured_formatting":{"main_text":"London Eye","main_text_matched_substrings":[{"length":6,"offset":0}],"secondary_text":"London, UK"},"terms":[{"offset":0,"value":"London Eye"},{"offset":12,"value":"London"},{"offset":20,"value":"UK"}],"types":["tourist_attraction","point_of_interest","establishment"]},{"description":"London, ON, Canada","matched_substrings":[{"length":6,"offset":0}],"place_id":"ChIJC5uNqA7yLogRlWsFmmnXxyg","reference":"ChIJC5uNqA7yLogRlWsFmmnXxyg","structured_formatting":{"main_text":"London","main_text_matched_substrings":[{"length":6,"offset":0}],"secondary_text":"ON, Canada"},"terms":[{"offset":0,"value":"London"},{"offset":8,"value":"ON"},{"offset":12,"value":"Canada"}],"types":["locality","political","geocode"]},{"description":"London Bridge Station, London, UK","matched_substrings":[{"length":6,"offset":0}],"place_id":"ChIJ___OyFADdkgRkjYaWF6n5h0","reference":"ChIJ___OyFADdkgRkjYaWF6n5h0","structured_formatting":{"main_text":"London Bridge Station","main_text_matched_substrings":[{"length":6,"offset":0}],"secondary_text":"London, UK"},"terms":[{"offset":0,"value":"London Bridge Station"},{"offset":23,"value":"London"},{"offset":31,"value":"UK"}],"types":["point_of_interest","establishment"]}]);
  const [selectedAutocompleteResponse, setSelectedAutocompleteResponse] = useState();

  const {showErrorToast} = useContext(AppContext)

  const service = new window.google.maps.places.AutocompleteService();
  const geocoder = new window.google.maps.Geocoder();
  const sessionToken = new window.google.maps.places.AutocompleteSessionToken();

  useDebounce(async () => {
    if (locationQuery && service) {
      // console.log('locationQuery', locationQuery)
      setSelectedAutocompleteResponse(null)
      service.getPlacePredictions({
        input: locationQuery,
        sessionToken: sessionToken,
        types: ['locality', 'political']
      }, (response) => {
        setAutocompleteResponses(response)
      })

    }
  }, 500, [locationQuery])

  useEffect(() => {
    if (selectedAutocompleteResponse) {
      // console.log('selectedAutocompleteResponse', selectedAutocompleteResponse)
      setAutocompleteResponses([])
      setLocationQuery('')

      fetchLatLng(selectedAutocompleteResponse?.place_id)
        .then(({ lat, lng, countryCode, countryName }) => {
          onComplete({
            lat: lat,
            lng: lng,
            countryName: countryName,
            countryCode: countryCode,
            location: selectedAutocompleteResponse?.description
          })
      })
    }
  }, [selectedAutocompleteResponse])

  useEffect(() => {
    // console.log('defaultValue',defaultValue)
    if (defaultValue) {
      setLocationQuery(defaultValue)
    }
  }, [defaultValue])

  useEffect(() => {
    clearSelectAutocompleteResponse()
  }, [isFocused])

  const fetchLatLng = async (placeId) => {
    // console.log('fetching lat/lng for palceId', placeId)
    const {results} = await geocoder.geocode({ placeId: placeId })
    // console.log('geocode results', results)
    if (results[0]) {
      // console.log('result', results[0])
      // console.log('location', results[0].geometry.location)
      const location = results[0].geometry.location
      const addressComponents = results[0].address_components

      const countryComponents = addressComponents.filter(addr => addr.types.includes('country'))
      let countryComponent = countryComponents.length ? countryComponents[0] : null

      return {
        lat: location.lat(),
        lng: location.lng(),
        countryName: countryComponent?.long_name,
        countryCode: countryComponent?.short_name,
      }
    } else {
      // show error
      showErrorToast({message: 'Failed to fetch details for selected location'})
    }

  }

  const onLocationInput = (event) => {
    setLocationQuery(event.target.value)
  }

  const clearSelectAutocompleteResponse = () => {
    // console.log('clearing autocompelte response')

    if (defaultValue) {
      setLocationQuery(defaultValue)
    } else if (selectedAutocompleteResponse) {
      setLocationQuery(selectedAutocompleteResponse?.description + ' ')
    } else {
      setLocationQuery('')
    }
    setSelectedAutocompleteResponse(null)
  }


  const isAutocompleteRespOk = autocompleteResponses && autocompleteResponses.length > 0

  return (
    <VStack position={'relative'} width={'100%'}>
      <Input
        type={'text'}
        placeholder={'Enter your City...'}
        onChange={onLocationInput}
        onFocus={() => setIsFocued(true)}
        onBlur={() => setIsFocued(false)}
        value={selectedAutocompleteResponse ? selectedAutocompleteResponse?.description : locationQuery}
      />
      <Collapse
        in={locationQuery && isFocused}
        animateOpacity
      >
        <Card
          position={'absolute'}
          zIndex={1}
          display={locationQuery ? 'flex' : 'none'}
          left={0}
          top={10}
        >
          <VStack width={'100%'} align={'left'} >
          {isAutocompleteRespOk ? autocompleteResponses?.map(ac =>
            <Button
              key={ac?.place_id}
              width={'100%'}
              variant={'ghost'}
              justifyContent={'start'}
              onClick={() => setSelectedAutocompleteResponse(ac)}
            >
              <Text>{ac.description}</Text>
            </Button>
          )
          :
            <>
            <Text textAlign={'left'}>No results found</Text>
            </>
          }
          </VStack>
        </Card>
      </Collapse>
    </VStack>
  )
}

export default LocationInput;
